var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mdc-text-field-helper-line"},[_c('div',_vm._b({staticClass:"mdc-text-field-helper-text",attrs:{"aria-hidden":"true"}},'div',_vm.$attrs,false),[_vm._t("default")],2),_vm._t("characterCounter")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }